module.exports = __webpack_public_path__ + "img/98.f176aab4.svg";